export const colors = {
  light_blue: '#e2f4fb',
  blue: '#26a3c5',
  dark_blue: '#24476a',
  grey: '#999999',
  dark_grey: '#333333',
  red: '#db4646',
};
